import { biLogger } from '../biLogger';
import { locale } from '../constants';
import { selectBiData } from '../selectors';
import { BiEventLogger } from '../types';
import { getRuntimeDataForBi } from '../utils';

export const logConnectionLostMessagePresented: BiEventLogger = async (state) => {
  const biData = selectBiData(state);
  const { conversationId = '' } = biData;
  const { sessionId = '', contextBi } = await getRuntimeDataForBi(state);

  biLogger.chatbotConnectionLostMessagePresented({
    conversation_id: conversationId,
    session_id: sessionId,
    chatbot_view: contextBi?.chatbot_view,
    lang: locale,
    extra_fields: undefined,
  });
};
